/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 10th March 2019
 *
 * Page Loader
 */
import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useStores } from 'stores/RootStore';
import { withStyles } from '@material-ui/core/styles';

const PageLoader = props => {
  const { classes } = props;
  const stores = useStores();

  stores.portalStore.loading.isPageLoading
    ? stores.appStore.debug('Component::PageLoader - Rendered successfully.')
    : stores.appStore.debug('Component::PageLoader - Hidden successfully.');

  return stores.portalStore.loading.isPageLoading ? <LinearProgress className={classes.pageLoader} /> : null;
};

PageLoader.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  pageLoader: {},
});

export default withStyles(styles, { withTheme: true })(observer(PageLoader));
